import { concat } from "ramda";

// Redux Prefix
const prefix = concat("MODAL:");

const OPEN_MODAL = prefix("OPEN_MODAL");
const CLOSE_MODAL = prefix("CLOSE_MODAL");

const INITIAL_STATE = {
  isModalOpen: false,
};

// Actions
export const openModal = () => ({
  type: OPEN_MODAL,
});

export const closeModal = () => ({
  type: CLOSE_MODAL,
});

// Reducer
export default function reducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case OPEN_MODAL:
      return {
        ...state,
        isModalOpen: true,
      };
    case CLOSE_MODAL:
      return {
        ...state,
        isModalOpen: false,
      };
    default:
      return state;
  }
}
